/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import axios from '../constants/axiosConfig';
import {
  Sessao,
  setSessaoToken,
  limparSessao,
  setSessaoUsuario,
  SessaoUsuario,
} from '../helpers/token';
import keycloack from '../keycloak';

const CONTA_URL = process.env.REACT_APP_CONTA_URL;
const TERMO_API_URL = process.env.REACT_APP_TERMO_API_URL;

export const isDevelopment = () => process.env.NODE_ENV === 'development';

export const isAuthenticated = () => {
  const token = Sessao('access_token');
  return !!token;
};

export const setContratoAceito = async () => {
  try {
    const { status, data } = await axios({
      baseURL: TERMO_API_URL,
      method: 'post',
      url: `verificaContratoAceito/5`,
    });
    const contratoAceito = status === 200 && data.sucesso;
    localStorage.setItem('_20ex20', contratoAceito);
    return contratoAceito;
  } catch (error) {
    return false;
  }
};

export const isContratoAceito = async () => {
  if (JSON.parse(localStorage.getItem('_20ex20'))) {
    return true;
  }

  // eslint-disable-next-line no-return-await
  return await setContratoAceito();
};

export const buscarDadosCliente = async () => {
  const { pathname } = window.location;

  await axios
    .get('usuario/obterDadosUsuario', { signal: AbortSignal.timeout(5000) })
    .then(async ({ data, status }) => {
      if (status === 200) {
        const {
          email,
          codigoCliente,
          nome,
          isAdmin,
          clienteStatus,
          razaoSocialCliente: clienteRazaoSocial,
          planoRecuperadorLimitado,
          fotoPerfil,
        } = data;

        setSessaoUsuario({
          isAdmin,
          email,
          clienteRazaoSocial,
          planoRecuperadorLimitado,
          fotoPerfil,
        });

        localStorage.setItem('nome', nome);
        localStorage.setItem('email', email);
        localStorage.setItem('status', clienteStatus);

        window?.clarity?.('identify', email);
        window?.clarity?.('set', 'Login usuário', email);
        window?.clarity?.('set', 'Código cliente', codigoCliente);

        if (pathname === '/') window.location = '/home';
      } else {
        window.location = CONTA_URL;
      }
    })
    .catch((err) => {
      console.log(err);
      window.location = CONTA_URL;
    });
};

export const getToken = () => Sessao('access_token');

export const logout = () => {
  localStorage.clear();
  keycloack
    .logout({ redirectUri: process.env.REACT_APP_CONTA_URL })
    .then(() => {
      limparSessao();
    })
    .catch(() => {
      limparSessao();
      window.location = process.env.REACT_APP_CONTA_URL;
    });
};

export const setUsuario = (usuario, email) => {
  usuario.conteudo.email = email;
  usuario.conteudo.access_token = usuario.conteudo.accessToken;
  setSessaoToken(usuario.conteudo);
  localStorage.setItem('email', email);
};

export const getEmailLogged = () => SessaoUsuario('email');

export const getContaTeste = () => {
  const status = localStorage.getItem('status');
  return status ? status.toLowerCase() === 'teste' : false;
};

export const getContaPlanoRecuperadorLimitado = () => SessaoUsuario('planoRecuperadorLimitado');
